export const LANGUAGES={
    EN:"English",
    CH:'中文',
}